/**
 * Common types and utilities for inspections
 */
import type { SourceEntityIdentifier } from 'entity-identifiers';

/** Schema version for client compatibility */
export const CURRENT_SCHEMA_VERSION = '1.0.0' as const;

export type SchemaVersion = typeof CURRENT_SCHEMA_VERSION;

/**
 * gRPC source type string for unknown/unrecognized source types.
 * Used in mappers to test fallback behavior when source type is not recognized.
 */
export const SOURCE_TYPE_UNKNOWN = 'SOURCE_TYPE_UNKNOWN';

/**
 * Asset types that templates can be applied to
 */
export type AssetType =
  | 'industrial'
  | 'retail'
  | 'office'
  | 'residential'
  | 'mixed_use';

export type { SourceEntityIdentifier };
